module.exports = __webpack_public_path__ + "static/media/javascript-plain.b3901c8e.svg";